<template>
  <Dialog :common-dialog="productDialog" :dialog-width="dialog_width">
    <template v-slot:title>
      <v-layout class="align-items-center justify-space-between w-100 px-2">
        <div class="d-flex align-items-center">
          <v-avatar size="36" color="cyan lighten-5" class="mr-3">
            <v-icon color="cyan darken-2" small>mdi-package-variant-closed</v-icon>
          </v-avatar>
          <div class="font-weight-700 color-custom-blue d-flex align-items-center">
            Select
            <span class="text-capitalize ml-1">
              <template v-if="productType == 'tools'"> Tools</template>
              <template v-else-if="productType == 'equipment'">
                Equipment</template>
              <template v-else-if="productType == 'goods'"> Products</template>
              <template v-else> {{ productType }}</template>
            </span>
            <v-chip label small color="cyan lighten-5" class="ml-3 cyan--text text--darken-3 font-weight-600">
              {{ getSelectedItem }} Selected
            </v-chip>
          </div>
        </div>
        <v-flex class="text-right">
          <v-btn style="height: 32px !important" class="custom-bold-button mr-2" depressed :disabled="vStateLoading"
            color="cyan white--text" v-on:click="save_line_item()">Save</v-btn>
          <v-btn style="height: 32px !important" class="custom-bold-button" depressed :disabled="vStateLoading"
            v-on:click="$emit('close', true)">Close</v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="px-2 pb-2">
        <!-- Toolbar Card -->

        <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
          <v-text-field ref="lineItemSearch" v-model="search" class="custom-erp-input bg-white rounded-lg flex-grow-1"
            placeholder="Search..." @click:clear="clearSearch" dense filled solo :disabled="vStateLoading" clearable
            flat hide-details color="cyan" prepend-inner-icon="mdi-magnify" style="max-width: 400px"
            v-on:keydown.enter.prevent="handleFilterChange(true)" />
          <v-btn style="height: 32px !important" class="custom-bold-button ml-2" depressed :disabled="vStateLoading"
            v-on:click="handleFilterChange()" color="cyan white--text">Search</v-btn>
          <v-autocomplete hide-details v-model.trim="filter_categoty" :items="vLineItemCategory" clearable
            v-on:click:clear="filter_categoty = null" style="max-width: 250px !important" dense flat filled
            placeholder="Category" item-color="cyan" class="ml-2 bg-white rounded-lg" color="cyan" solo
            v-on:change="filter_cat($event)" item-value="value" item-text="label" :menu-props="{ offsetY: true }">
          </v-autocomplete>
        </div>

        <!-- Product Table Card -->
        <v-card flat outlined class="rounded-lg border-slate bg-white overflow-hidden mb-2 shadow-0">
          <div class="d-flex grey lighten-4 border-bottom py-2 px-3 align-items-center">
            <div class="font-weight-700 text-left d-flex justify-cente pl-2" style="width: 5%">
              <v-checkbox :input-value="isAllVisibleSelected" v-on:change="update_all_line_item($event)" hide-details
                :disabled="vStateLoading" class="my-0 py-0 px-0 mx-0 dense-checkbox" color="cyan" />
            </div>
            <div
              class="color-custom-blue font-weight-700 text-left text-uppercase font-size-14 d-flex align-items-center"
              :style="productType == 'goods' || productType == 'parts'
                  ? 'width: 35%'
                  : ' width: 45%'
                ">
              <v-icon small color="cyan darken-2" class="mr-1">mdi-package-variant-closed</v-icon>
              <template v-if="productType == 'tools'"> Tools</template>
              <template v-else-if="productType == 'equipment'">
                Equipment</template>
              <template v-else-if="productType == 'goods'"> Products</template>
              <template v-else>{{ productType }}</template>
            </div>
            <div v-if="productType == 'goods' || productType == 'parts'"
              class="color-custom-blue font-weight-700 text-left text-uppercase font-size-14 d-flex align-items-center"
              style="width: 20%">
              <v-icon small color="cyan darken-2" class="mr-1">mdi-cube-outline</v-icon>
              Available Quantity
            </div>
            <div
              class="color-custom-blue font-weight-700 text-left text-uppercase font-size-14 d-flex align-items-center"
              :style="productType == 'goods' || productType == 'parts'
                  ? 'width: 20%'
                  : ' width: 25%'
                ">
              <v-icon small color="cyan darken-2" class="mr-1">mdi-cash-multiple</v-icon>
              Selling/Unit Cost
            </div>
            <div
              class="color-custom-blue font-weight-700 text-left text-uppercase font-size-14 d-flex align-items-center"
              style="width: 10%">
              <v-icon small color="cyan darken-2" class="mr-1">mdi-ruler-square</v-icon>
              UOM
            </div>
            <div
              class="color-custom-blue font-weight-700 text-left text-uppercase font-size-14 d-flex align-items-center"
              :style="productType == 'goods' || productType == 'parts'
                  ? 'width: 20%'
                  : ' width: 25%'
                ">
              <v-icon small color="cyan darken-2" class="mr-1">mdi-numeric</v-icon>
              Quantity
            </div>
          </div>
          <div style="overflow-y: scroll; max-height: calc(100vh - 360px)">
            <div v-if="vStateLoading" class="my-4 py-4">
              <v-progress-linear color="cyan" indeterminate rounded height="6"></v-progress-linear>
            </div>
            <div v-else-if="vLineItem && vLineItem.length">
              <div v-for="(row, index) in vLineItem" :key="index"
                class="d-flex align-items-top py-2 border-bottom-dashed custom_row"
                :class="getDisabled(row) ? 'eqp-opacity' : ''">
                <div class="font-weight-600 text-center d-flex justify-center" style="width: 5%">
                  <v-checkbox v-model="row.status" :disabled="getDisabled(row)" hide-details
                    class="my-0 py-0 px-0 mx-0 dense-checkbox" color="cyan" @change="updateSelection(row)" />
                </div>
                <div class="text-left" :style="productType == 'goods' || productType == 'parts'
                    ? 'width: 35%'
                    : ' width: 45%'
                  ">
                  <div class="d-flex align-items-top">
                    <div class="d-flex align-items-top mr-2">
                      <v-avatar size="32" class="mr-2">
                        <img v-if="row?.image?.url" :src="row?.image?.url" :alt="row?.image?.name" />
                        <img v-else :src="$defaultImage" />
                      </v-avatar>
                      <div v-if="row.has_property" class="font-weight-600 d-flex align-items-top mb-1">
                        <template v-if="
                            /* productType == 'equipment' &&  */ row &&
                          row.barcode
                        ">
                          <v-chip label color="chip-custom-blue" outlined x-small class="text-white px-1 mt-1"
                            style="font-weight: 700">{{ row.barcode }}</v-chip>
                        </template>
                      </div>
                    </div>
                    <div style="width: 100%" class="ml-0">
                      <v-text-field v-model="row.product" class="line-item-header-text px-0" :placeholder="productType"
                        dense filled solo flat color="cyan" :disabled="getDisabled(row)">
                        <template v-slot:append>
                          <div class="line-item-serial-meta d-flex align-center">
                            <v-chip v-if="productType == 'goods' || productType == 'parts'"
                              :color="row?.isSerialized ? 'green darken-1' : 'red lighten-1'"
                              class="font-weight-600 ml-2" small label text-color="white">
                              {{ row?.isSerialized ? "Serialized" : "Non-serialized" }}
                            </v-chip>
                          </div>
                        </template>
                      </v-text-field>
                      <v-textarea v-if="false" class="px-0" v-model="row.description" placeholder="Description" dense
                        filled solo flat rows="2" auto-grow color="cyan" :disabled="getDisabled(row)" />

                      <!--   <v-checkbox
                           v-if="row.type == 'product'"
                          inset
                          color="cyan"
                          label="As Equipment"
                          dense
                          class="pt-0 mt-2"
                          v-model="row.is_equipment" 
                          hide-details
                          :false-value="0"
                          :true-value="1"
                        > 
                      </v-checkbox>  -->
                      <div v-if="row.has_property" class="font-weight-600 d-flex align-items-center">
                        <!-- <template
                          v-if="
                            productType == 'equipment' && row && row.serial_no
                          "
                        >
                          <v-chip
                            label
                            color="chip-custom-blue"
                            outlined
                            class="text-white p-3 mr-2"
                            style="font-weight: 700; margin-top: -6px"
                            >{{ row.serial_no }}</v-chip
                          >
                        </template> -->
                        <!--  <template v-if="row?.property?.parent?.name">
                          <v-chip small>{{ row.property.parent.name }}</v-chip>
                          <v-icon class="px-1">mdi-chevron-right</v-icon>
                        </template>
                        <template v-if="row?.property?.child?.name">
                          <v-chip small style="padding: 12px !important">{{
                            row.property.child.name
                          }}</v-chip>
                          <v-icon class="px-1">mdi-chevron-right</v-icon>
                        </template>
                        <template v-if="row?.property?.type == 'child-child-'">
                          <v-chip small style="padding: 12px !important">
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-if="row?.property?.type == 'child-'">
                          <v-chip small style="padding: 12px !important">
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-if="row?.property?.type == 'parent-'">
                          <v-chip
                            small
                            style="padding: 12px !important"
                            v-if="row?.property?.property_name"
                          >
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template> -->
                        <template v-if="
                          productType != 'goods' &&
                          row &&
                          row.has_warranty &&
                          row.has_warranty > 0
                        ">
                          <v-chip :color="getWarrantyStatusColor(row.warranty_status)" small text-color="white"
                            class="ml-2">
                            Warranty
                          </v-chip>
                        </template>
                        <template v-if="
                          (productType == 'equipment' ||
                            productType == 'tools') &&
                          row &&
                          row.preventive_id &&
                          row.preventive_id > 0 &&
                          showModules.preventive_maintanance
                        ">
                          <v-chip :color="row?.is_consumed ? 'red' : 'lightgray'" class="ml-2" small text-color=""
                            outlined v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.preventive_id,
                                'admin.preventive-maintanance.detail'
                              )
                              ">
                            {{ row.preventive_barcode }}
                          </v-chip>
                        </template>
                        <template v-if="
                          productType == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_id > 0 &&
                          showModules.location
                        ">
                          <v-chip :color="row?.is_consumed ? 'red' : 'lightgray'" class="ml-2" small text-color=""
                            outlined v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.preventive_id,
                                'admin.preventive-maintanance.detail'
                              )
                              ">
                            {{ row.location }}
                          </v-chip>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="productType == 'goods' || productType == 'parts'" class="text-center" style="width: 20%">
                  <v-text-field class="line-item-header-text px-0" placeholder="Available Quantity" dense filled solo
                    type="number" v-model="row.initial_stock" flat :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.initial_stock)" color="cyan" :readonly="productType == 'parts' ||
                      productType == 'tools' ||
                      productType == 'goods'
                      " />
                </div>
                <!-- <div
                  class="text-center"
                  style="width: 20%"
                  v-if="productType == 'equipment'"
                >
                  <v-autocomplete
                    class="line-item-header-text px-0"
                    placeholder="Sub-Location"
                    :items="subLocationList"
                    dense
                    filled
                    solo
                    type="text"
                    v-model="row.location"
                    flat
                    :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.location)"
                    color="cyan"
                  />
                </div> -->
                <div class="text-center" :style="productType == 'goods' || productType == 'parts'
                    ? 'width: 20%'
                    : ' width: 25%'
                  ">
                  <v-tooltip v-if="Number(row.customer_latest_quoted_rate) > 0" top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" class="line-item-header-text px-0"
                        placeholder="Selling/Unit Cost" dense filled solo type="number" v-model="row.rate" flat
                        :disabled="getDisabled(row)" v-on:keypress="limitDecimal($event, row.rate)" color="cyan" />
                    </template>
                    <div>
                      Latest price :
                      {{ formatMoney(row.customer_latest_quoted_rate || 0) }}
                    </div>
                  </v-tooltip>
                  <v-text-field v-else class="line-item-header-text px-0" placeholder="Selling/Unit Cost" dense filled
                    solo type="number" v-model="row.rate" flat :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.rate)" color="cyan" />
                </div>
                <div>
                  <v-autocomplete dense filled color="cyan" item-color="cyan" :items="vLineItemUnit" placeholder="UOM"
                    solo flat item-text="text" item-value="text" class="pr-0 width-33" v-model.trim="row.uom">
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title v-html="'No UOM Found.'"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="text-center" :style="productType == 'goods' || productType == 'parts'
                    ? 'width: 20%'
                    : ' width: 25%'
                  ">
                  <v-text-field :readonly="productType == 'equipment' || productType == 'tools'
                    " class="line-item-header-text px-0" placeholder="Quantity" dense filled type="number"
                    v-model="row.quantity" :disabled="getDisabled(row)" solo flat
                    v-on:keyup="checkAvailableQuantity(row)" v-on:keypress="isNumber($event)" color="cyan" />
                </div>
              </div>
            </div>
            <div v-else>
              <p class="m-0 row-not-found text-center font-weight-500 font-size-16 py-4">
                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                Uhh... There are no item at the moment.
              </p>
            </div>
          </div>
          <ListingFooter :dataLoading="vStateLoading" :showingFrom="showingFrom" :showingTo="showingTo"
            :totalRows="totalItems" :currentPage="currentPage" :totalPages="totalPages" removePage />
        </v-card>
      </div>
    </template>
  </Dialog>
</template>
<script>
import { mapGetters } from "vuex";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { GET_LINE_ITEM, SET_LOADING } from "@/core/services/store/visit.module";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import CommonMixin from "@/core/plugins/common-mixin.js";

export default {
  name: "line-item-dialog-v2",
  mixins: [CommonMixin],
  props: {
    productType: {
      type: String,
      default: null,
    },
    productDialog: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: Number,
      default: 0,
    },
    supplier: {
      type: [Number, String],
      default: 0,
    },
    unitList: {
      type: Array,
      default: () => [],
    },
    isType: {
      type: Number,
      default: 0,
    },
    visitId: {
      type: Number,
      default: 0,
    },
    salesExecutive: {
      type: [Number, String],
      default: 0,
    },
    quotationId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      search: null,
      category: "all",
      alphabet: "all",

      filter_categoty: null,
      selectedBarcodes: [],
      selectedItems: [],
      currentPage: 1,
      perPage: 20,
      totalPages: 1,
      totalItems: 0,
    };
  },
  components: {
    Dialog,
    ListingFooter,
  },
  methods: {
    updateSelection(row) {
      if (row.status) {
        if (!this.selectedBarcodes.includes(row.barcode)) {
          this.selectedBarcodes.push(row.barcode);
          this.selectedItems.push({ ...row });
        } else {
          const index = this.selectedItems.findIndex(
            (item) => item.barcode === row.barcode
          );
          if (index > -1) {
            this.selectedItems[index] = { ...row };
          }
        }
      } else {
        this.selectedBarcodes = this.selectedBarcodes.filter(
          (barcode) => barcode !== row.barcode
        );

        this.selectedItems = this.selectedItems.filter(
          (item) => item.barcode !== row.barcode
        );
      }
    },
    clearSearch() {
      this.search = null;
      this.handleFilterChange();
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    checkAvailableQuantity(row) {
      if (row.product_type == "goods" || row.product_type == "parts") {
        if (Number(row.quantity) > Number(row.initial_stock)) {
          ErrorEventBus.$emit(
            "update:error",
            "Quantity exceeds available quantity"
          );
          return (row.quantity = row.initial_stock);
        }
      }
    },
    getDisabled(row) {
      if (
        this.moduleType &&
        this.moduleType == 7 &&
        row?.preventive_id > 0 &&
        row?.item_count > 0
      ) {
        return true;
      }
      return false;
    },
    handleFilterChange(restoreFocus = false) {
      this.currentPage = 1;
      this.find_items(1, restoreFocus);
    },
    focusSearchInput() {
      const searchInput = this.$refs.lineItemSearch?.$el?.querySelector(
        "input"
      );
      if (searchInput && !searchInput.disabled) {
        searchInput.focus();
      }
    },
    find_items(page = 1, restoreFocus = false) {
      let productType = this.productType;
      if (productType == "product") {
        productType = "goods";
      }
      this.currentPage = Number(page) > 0 ? Number(page) : 1;
      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(GET_LINE_ITEM, {
          type: productType,
          search: this.search,
          category: this.category,
          alphabet: this.alphabet,
          customer: productType != "tools" ? this.vCustomerId : 0,
          sales_executive:
            Number(this.salesExecutive) > 0 ? Number(this.salesExecutive) : null,
          quotation_id:
            Number(this.quotationId) > 0 ? Number(this.quotationId) : null,
          supplier: Number(this.supplier) > 0 ? Number(this.supplier) : null,
          start_date: this.prventiveRecurringSchedule?.start_date || null,
          end_date: this.prventiveRecurringSchedule?.dbEndDate || null,
          per_page: this.perPage,
          current_page: this.currentPage,
        })
        .then((output) => {
          // const pagination = output?.pagination || {};
          this.totalPages = output.total_pages || 1;
          this.totalItems = output.total_rows || this.vLineItem.length;
          this.vLineItem.forEach((item) => {
            item.status = this.selectedBarcodes.includes(item.barcode);
          });
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.$store.dispatch(SET_LOADING, false).then(() => {
            if (restoreFocus) {
              this.$nextTick(() => {
                this.focusSearchInput();
              });
            }
          });
        });
    },
    changePage(page) {
      if (page) {
        this.find_items(page);
      }
    },
    handlePaginationUpdate(page) {
      this.currentPage = page;
      this.find_items(page);
    },
    // save_line_item() {
    //   let selected_line_items = [];

    //   let status = false;
    //   for (let item of this.vLineItem) {
    //     if (item.status) {
    //       status = true;
    //       selected_line_items.push(item);
    //     }
    //   }
    //   let error = true;

    //   if (selected_line_items?.length > 0 && this.isType == 7) {
    //     for (let item of selected_line_items) {
    //       this.vSelectedLineItem.forEach((row) => {
    //         if (row.barcode == item.barcode) {
    //           ErrorEventBus.$emit(
    //             "update:error",
    //             `${item.barcode} already used `
    //           );
    //           error = false;
    //           return false;
    //         }
    //       });
    //     }
    //   }
    //   if (!error && this.isType == 7) {
    //     return false;
    //   }
    //   if (!status) {
    //     ErrorEventBus.$emit("update:error", `Please select Item.`);
    //     return false;
    //   }
    //   this.$emit("update-values", selected_line_items);
    //   this.$emit("close", true);
    // },
    save_line_item() {
      let selected_line_items = [...this.selectedItems];

      let error = true;

      if (selected_line_items?.length > 0 && this.isType == 7) {
        for (let item of selected_line_items) {
          this.vSelectedLineItem.forEach((row) => {
            if (row.barcode == item.barcode) {
              ErrorEventBus.$emit(
                "update:error",
                `${item.barcode} already used `
              );
              error = false;
              return false;
            }
          });
        }
      }
      if (!error && this.isType == 7) {
        return false;
      }

      if (!selected_line_items.length) {
        ErrorEventBus.$emit("update:error", "Please select Item.");
        return false;
      }

      this.$emit("update-values", selected_line_items);
      this.$emit("close", true);
    },
    // update_all_line_item(status) {
    //   if (this.moduleType == 7) {
    //     for (let i = 0; i < this.vLineItem.length; i++) {
    //       if (
    //         /* this.vLineItem[i].preventive_id == 0 &&  */ this.vLineItem[i]
    //           .item_count == 0
    //       ) {
    //         this.vLineItem[i].status = status;
    //       }
    //     }
    //   } else {
    //     for (let i = 0; i < this.vLineItem.length; i++) {
    //       this.vLineItem[i].status = status;
    //     }
    //   }
    // },
    update_all_line_item(status) {
      if (!status) {
        // Deselect only the visible current page items; keep selections from other pages.
        this.vLineItem.forEach((item) => {
          item.status = false;
          this.selectedBarcodes = this.selectedBarcodes.filter(
            (barcode) => barcode !== item.barcode
          );
          this.selectedItems = this.selectedItems.filter(
            (selected) => selected.barcode !== item.barcode
          );
        });
        return;
      }

      // Select only the visible current page items and retain previous page selections.
      this.vLineItem.forEach((item) => {
        if (this.moduleType == 7 && item.item_count != 0) {
          return;
        }

        item.status = true;

        if (!this.selectedBarcodes.includes(item.barcode)) {
          this.selectedBarcodes.push(item.barcode);
          this.selectedItems.push({ ...item });
        }
      });
    },
    filter_cat(param) {
      this.category = param;
      this.handleFilterChange();
    },
    filter_alpha(param) {
      this.alphabet = param;
      this.handleFilterChange();
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination", this.handlePaginationUpdate);
  },
  mounted() {
    PaginationEventBus.$on("update:pagination", this.handlePaginationUpdate);
    if (this.productDialog) {
      this.handleFilterChange();
    }
  },
  computed: {
    ...mapGetters([
      "vCustomerId",
      "vLineItem",
      "vLineItemAlpha",
      "vStateLoading",
      "vLineItemCategory",
      "vLineItemUnit",
      "vSelectedLineItem",
      "prventiveRecurringSchedule",
    ]),
    dialog_width() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 80);
    },
    // getSelectedItem() {
    //   return this.vLineItem.filter((item) => item.status).length;
    // },
    getSelectedItem() {
      return this.selectedItems.length;
    },
    isAllVisibleSelected() {
      if (!this.vLineItem || !this.vLineItem.length) {
        return false;
      }
      return this.vLineItem.every((item) =>
        this.selectedBarcodes.includes(item.barcode)
      );
    },
    showingFrom() {
      return this.totalItems ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },
    showingTo() {
      return this.totalItems
        ? Math.min(this.currentPage * this.perPage, this.totalItems)
        : 0;
    },
  },
};
</script>
<style scoped>
.custom_row {
  border-bottom: 1.5px solid #dbd7d7;
}

.custom_row:nth-child(even) {
  background: #fff4de;
}

.custom_row:hover {
  background: #fff4de;
}
</style>
